"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_2 = require("react");
var react_i18next_1 = require("react-i18next");
var GameList = function (props) {
    var _a = (0, react_1.useState)(), value = _a[0], setValue = _a[1];
    var _b = (0, react_1.useState)([]), list = _b[0], setList = _b[1];
    var _c = (0, react_i18next_1.useTranslation)(), t = _c.t, i18n = _c.i18n;
    (0, react_1.useEffect)(function () {
        setValue(props.caption);
        setList(props.list);
        /*
        axios.get<Game[]>(`/app/game/alphabet/${props.caption}`)
            .then((response) => {
                setList(response.data);
            });
        */
    }, [props]);
    return (react_1.default.createElement(react_2.Fragment, null,
        props.isViewButton && react_1.default.createElement("div", { style: { marginTop: "40px", minWidth: "162px" }, className: "__empty-game-list " },
            react_1.default.createElement("div", { style: { paddingLeft: "12px" }, onClick: props.onBackClick, className: "__to-all-game" }, t("page.index.to-all-game.button"))),
        react_1.default.createElement("div", { className: "__alphabet" }, props.caption),
        list && list.map(function (item, index) {
            var _a;
            return react_1.default.createElement("div", { key: index, className: "__item" },
                react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("a", { href: item.link },
                        react_1.default.createElement("div", { className: "__game-card __height-small " },
                            react_1.default.createElement("div", { className: "__text-small" }, item.name))),
                    item.sub_game && item.sub_game.length > 0 &&
                        react_1.default.createElement("div", { className: "__game-server-conteiner" },
                            react_1.default.createElement("div", null,
                                react_1.default.createElement("a", { href: item.link }, item.sub_name)), (_a = item.sub_game) === null || _a === void 0 ? void 0 :
                            _a.map(function (_item, _index) {
                                return react_1.default.createElement("div", { key: _index },
                                    react_1.default.createElement("a", { href: _item.link }, _item.sub_name));
                            }))));
        })));
};
exports.default = GameList;
